var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "order-details" }, [
    _c("h1", [_vm._v("Order Details")]),
    _vm.isCorrectOrderLoaded
      ? _c("div", [
          _c("div", { staticClass: "info-section" }, [
            _c("div", { staticClass: "columns" }, [
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Customer")]),
                  _c("p", { staticClass: "control" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.displayOrder.firstName) +
                        " " +
                        _vm._s(_vm.displayOrder.lastName) +
                        " "
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Email")]),
                  _c("p", { staticClass: "control" }, [
                    _vm._v(_vm._s(_vm.displayOrder.email))
                  ])
                ])
              ]),
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Order ID")]),
                  _c("p", { staticClass: "control" }, [
                    _vm._v(_vm._s(_vm.displayOrder.orderId))
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "columns" }, [
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Order Date")]),
                  _c("p", { staticClass: "control" }, [
                    _vm._v(_vm._s(_vm.formatDate(_vm.displayOrder.created)))
                  ])
                ])
              ]),
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Payment Intent")
                  ]),
                  _c("p", { staticClass: "control" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.displayOrder.paymentIntent &&
                            _vm.displayOrder.paymentIntent.trim()
                            ? _vm.displayOrder.paymentIntent
                            : "N/A"
                        ) +
                        " "
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Discount Code")
                  ]),
                  _c("p", { staticClass: "control" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.displayOrder.discountCode || "None") +
                        " "
                    )
                  ])
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "section" }, [
            _c("h4", [_vm._v("Order Summary")]),
            _vm.orderLineItems && _vm.orderLineItems.length > 0
              ? _c("div", { staticClass: "table-wrapper" }, [
                  _c(
                    "table",
                    { staticClass: "table is-fullwidth line-items-table" },
                    [
                      _vm._m(0),
                      _c(
                        "tbody",
                        [
                          _vm._l(_vm.orderLineItems, function(item) {
                            return _c("tr", { key: item.id }, [
                              _c("td", [
                                _c(
                                  "span",
                                  { staticClass: "is-hidden-mobile" },
                                  [_vm._v(_vm._s(_vm.formatDate(item.date)))]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "is-hidden-tablet" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.formatDateShort(item.date))
                                    )
                                  ]
                                )
                              ]),
                              _c("td", [_vm._v(_vm._s(item.eventTitle))]),
                              _c("td", [
                                _c(
                                  "span",
                                  { staticClass: "is-hidden-mobile" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.description ||
                                          item.tierName ||
                                          "Ticket"
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "is-hidden-tablet" },
                                  [
                                    _vm._v(
                                      _vm._s(item.quantity) +
                                        " - " +
                                        _vm._s(
                                          item.description ||
                                            item.tierName ||
                                            "Ticket"
                                        )
                                    )
                                  ]
                                )
                              ]),
                              _c("td", { staticClass: "is-hidden-mobile" }, [
                                _vm._v(_vm._s(item.quantity))
                              ]),
                              _c(
                                "td",
                                {
                                  staticClass: "has-text-right is-hidden-mobile"
                                },
                                [
                                  _vm._v(
                                    " $" +
                                      _vm._s(_vm.formatCurrency(item.price)) +
                                      " "
                                  )
                                ]
                              ),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  " $" +
                                    _vm._s(_vm.formatCurrency(item.total)) +
                                    " "
                                )
                              ])
                            ])
                          }),
                          _vm.displayOrder.donation &&
                          _vm.displayOrder.donation > 0
                            ? _c("tr", [
                                _c("td", [
                                  _c(
                                    "span",
                                    { staticClass: "is-hidden-mobile" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDate(
                                            _vm.displayOrder.created
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "is-hidden-tablet" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDateShort(
                                            _vm.displayOrder.created
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.displayOrder.eventTitle))
                                ]),
                                _vm._m(1),
                                _c("td", { staticClass: "is-hidden-mobile" }, [
                                  _vm._v("1")
                                ]),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "has-text-right is-hidden-mobile"
                                  },
                                  [
                                    _vm._v(
                                      " $" +
                                        _vm._s(
                                          _vm.formatCurrency(
                                            _vm.displayOrder.donation
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _c("td", { staticClass: "has-text-right" }, [
                                  _vm._v(
                                    " $" +
                                      _vm._s(
                                        _vm.formatCurrency(
                                          _vm.displayOrder.donation
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                ])
              : !_vm.loadingLineItems
              ? _c("div", { staticClass: "table-wrapper" }, [
                  _c(
                    "table",
                    { staticClass: "table is-fullwidth line-items-table" },
                    [
                      _vm._m(2),
                      _c("tbody", [
                        _c("tr", [
                          _c("td", [
                            _c("span", { staticClass: "is-hidden-mobile" }, [
                              _vm._v(
                                _vm._s(_vm.formatDate(_vm.displayOrder.created))
                              )
                            ]),
                            _c("span", { staticClass: "is-hidden-tablet" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatDateShort(_vm.displayOrder.created)
                                )
                              )
                            ])
                          ]),
                          _c("td", [
                            _vm._v(_vm._s(_vm.displayOrder.eventTitle))
                          ]),
                          _c("td", [
                            _c("span", { staticClass: "is-hidden-mobile" }, [
                              _vm._v(
                                _vm._s(_vm.displayOrder.tierName || "Ticket")
                              )
                            ]),
                            _c("span", { staticClass: "is-hidden-tablet" }, [
                              _vm._v(
                                _vm._s(_vm.displayOrder.quantity) +
                                  " - " +
                                  _vm._s(_vm.displayOrder.tierName || "Ticket")
                              )
                            ])
                          ]),
                          _c("td", { staticClass: "is-hidden-mobile" }, [
                            _vm._v(_vm._s(_vm.displayOrder.quantity))
                          ]),
                          _c(
                            "td",
                            { staticClass: "has-text-right is-hidden-mobile" },
                            [
                              _vm._v(
                                " $" +
                                  _vm._s(
                                    _vm.formatCurrency(_vm.displayOrder.price)
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c("td", { staticClass: "has-text-right" }, [
                            _vm._v(
                              " $" +
                                _vm._s(
                                  _vm.formatCurrency(_vm.displayOrder.total)
                                ) +
                                " "
                            )
                          ])
                        ]),
                        _vm.displayOrder.donation &&
                        _vm.displayOrder.donation > 0
                          ? _c("tr", [
                              _c("td", [
                                _c(
                                  "span",
                                  { staticClass: "is-hidden-mobile" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDate(_vm.displayOrder.created)
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "is-hidden-tablet" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDateShort(
                                          _vm.displayOrder.created
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _c("td", [
                                _vm._v(_vm._s(_vm.displayOrder.eventTitle))
                              ]),
                              _vm._m(3),
                              _c("td", { staticClass: "is-hidden-mobile" }, [
                                _vm._v("1")
                              ]),
                              _c(
                                "td",
                                {
                                  staticClass: "has-text-right is-hidden-mobile"
                                },
                                [
                                  _vm._v(
                                    " $" +
                                      _vm._s(
                                        _vm.formatCurrency(
                                          _vm.displayOrder.donation
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  " $" +
                                    _vm._s(
                                      _vm.formatCurrency(
                                        _vm.displayOrder.donation
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                ])
              : _vm.loadingLineItems
              ? _c("div", { staticClass: "has-text-centered" }, [
                  _vm._m(4),
                  _vm._v(" Loading line items... ")
                ])
              : _vm._e(),
            _c("div", { staticClass: "receipt-totals" }, [
              _vm.displayOrder.subtotal
                ? _c("div", { staticClass: "total-line" }, [
                    _c("span", { staticClass: "total-label" }, [
                      _vm._v("Subtotal:")
                    ]),
                    _c("span", { staticClass: "total-amount" }, [
                      _vm._v(
                        "$" +
                          _vm._s(_vm.formatCurrency(_vm.displayOrder.subtotal))
                      )
                    ])
                  ])
                : _vm._e(),
              _vm.displayOrder.salesTax && _vm.displayOrder.salesTax > 0
                ? _c("div", { staticClass: "total-line" }, [
                    _c("span", { staticClass: "total-label" }, [
                      _vm._v("Sales Tax:")
                    ]),
                    _c("span", { staticClass: "total-amount" }, [
                      _vm._v(
                        "$" +
                          _vm._s(_vm.formatCurrency(_vm.displayOrder.salesTax))
                      )
                    ])
                  ])
                : _vm._e(),
              _c("div", { staticClass: "total-line total-final" }, [
                _vm._m(5),
                _c("span", { staticClass: "total-amount" }, [
                  _c("strong", [
                    _vm._v(
                      "$" + _vm._s(_vm.formatCurrency(_vm.displayOrder.total))
                    )
                  ])
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "resend-email-section" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary",
                attrs: { disabled: _vm.isResending },
                on: { click: _vm.resendConfirmationEmail }
              },
              [
                _vm.isResending
                  ? _c("span", { staticClass: "icon" }, [
                      _c("i", { staticClass: "fas fa-spinner fa-spin" })
                    ])
                  : _vm._e(),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.isResending
                        ? "Sending..."
                        : "Resend Confirmation Email"
                    ) +
                    " "
                )
              ]
            ),
            _vm.resendSuccess
              ? _c(
                  "div",
                  { staticClass: "notification is-success resend-message" },
                  [
                    _c("i", { staticClass: "fas fa-check" }),
                    _vm._v(" Confirmation email sent successfully! ")
                  ]
                )
              : _vm._e(),
            _vm.resendError
              ? _c(
                  "div",
                  { staticClass: "notification is-danger resend-message" },
                  [
                    _c("i", { staticClass: "fas fa-exclamation-triangle" }),
                    _vm._v(" " + _vm._s(_vm.resendError) + " ")
                  ]
                )
              : _vm._e()
          ])
        ])
      : _c("div", { staticClass: "has-text-centered" }, [
          _vm._m(6),
          _vm._v(" Loading order details... ")
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Date")]),
        _c("th", [_vm._v("Event")]),
        _c("th", [_vm._v("Description")]),
        _c("th", { staticClass: "is-hidden-mobile" }, [_vm._v("Quantity")]),
        _c("th", { staticClass: "has-text-right is-hidden-mobile" }, [
          _vm._v("Price")
        ]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v("Total")])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("span", { staticClass: "is-hidden-mobile" }, [_vm._v("Donation")]),
      _c("span", { staticClass: "is-hidden-tablet" }, [_vm._v("1 - Donation")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Date")]),
        _c("th", [_vm._v("Event")]),
        _c("th", [_vm._v("Description")]),
        _c("th", { staticClass: "is-hidden-mobile" }, [_vm._v("Quantity")]),
        _c("th", { staticClass: "has-text-right is-hidden-mobile" }, [
          _vm._v("Price")
        ]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v("Total")])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("span", { staticClass: "is-hidden-mobile" }, [_vm._v("Donation")]),
      _c("span", { staticClass: "is-hidden-tablet" }, [_vm._v("1 - Donation")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-spinner fa-spin" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "total-label" }, [
      _c("strong", [_vm._v("Total:")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-spinner fa-spin" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }